'use client';

import { c as _c } from "react/compiler-runtime";
import { Image } from '@/components/client';
import { useRankingList } from './_hooks/useRankingList';
import { RealtimeNotification } from './RealtimeNotification';
const MEDAL_IMAGES: Record<number, string> = {
  1: 'https://cdn.welfarehello.com/static/gold_medal.png',
  2: 'https://cdn.welfarehello.com/static/silver_medal.png',
  3: 'https://cdn.welfarehello.com/static/bronze_medal.png'
};
const RankBadge = t0 => {
  const $ = _c(10);
  const {
    rank
  } = t0;
  if (rank <= 3) {
    const t1 = MEDAL_IMAGES[rank];
    const t2 = `${rank}등`;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
      t3 = <Image src={t1} alt={t2} fill={true} sizes="32px" className="object-contain" />;
      $[0] = t1;
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== rank) {
      t4 = <span className="absolute inset-0 pt-8 font-700 text-Gray-white flex-center typo-caption1">{rank}</span>;
      $[3] = rank;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
      t5 = <div className="relative size-32">{t3}{t4}</div>;
      $[5] = t3;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  let t1;
  if ($[8] !== rank) {
    t1 = <div className="flex size-32 items-center justify-center"><p className="font-700 text-Gray-white typo-caption1">{rank}</p></div>;
    $[8] = rank;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export const RankingSection = () => {
  const $ = _c(7);
  const {
    data: rankingData
  } = useRankingList();
  if (rankingData && rankingData.length === 0) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RealtimeNotification />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="animate-fade-up text-center"><p className="font-800 text-Gray-white typo-h3">실시간 친구 기부 완료</p><p className="font-800 text-Gray-white typo-h3">TOP 10</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="gap-16 rounded-small py-4 font-700 text-R-50 flex-center typo-body4"><p className="w-100 text-center">순위</p><p className="w-172">닉네임</p><p className="w-100 text-center">친구 초대수</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== rankingData) {
    t3 = rankingData?.map(_temp);
    $[3] = rankingData;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <section className="w-full bg-[#e4302c]"><div className="mx-auto flex max-w-[375px] flex-col gap-48 px-20 py-40">{t0}<div className="flex flex-col items-center gap-20">{t1}<div className="flex w-full flex-col gap-4">{t2}{t3}</div></div></div></section>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(item, index) {
  return <div key={item.maskedNickname} className="flex animate-fade-up items-center justify-center gap-16 rounded-pill bg-Gray-white/20 py-8" style={{
    animationDelay: `${index * 80}ms`
  }}><RankBadge rank={index + 1} /><p className="w-172 truncate font-600 text-Gray-white typo-caption1">{item.maskedNickname}님</p><p className="w-40 text-center font-700 text-Gray-white typo-caption1">{index < 2 ? "?" : `${item.donationCount}명`}</p></div>;
}